import React, { children, useEffect, useState } from "react";
import { Wrapper, Content,StyledLink, Burger } from "./SidePanel.styles";
import { Link } from "react-router-dom";

const Sidepanel = ({children,open, onClick}) => {



   return (
    <>
    
     <Burger open={open} onClick={onClick}>☰</Burger>
    <Wrapper open={open} onClick={onClick} > 
        <Content open={open}>
            {children}
        </Content>
        
    </Wrapper>
    </>
   ); 

};

export default Sidepanel